//=include _respond.min.js
//=include _jquery-1.11.0.min.js
//=include _jquery.easing.min.js
//=include _jquery.easing.compatibility.js
//=include _jquery.fs.shifter.min.js
//=include _jquery.fancybox.min.js
//=include _jquery.reject.min.js
//=include _snap.svg-min.js
//=include _wow.min.js
//=include _select2.min.js
//=include _lazyload.min.js
//=include _framework.js
//=include _general.js
